// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3sR2a","clinicsSelect":"TableHeading_clinicsSelect__1j_Dw"};